import type { CompleteFieldSelector } from '@/types/fields-api.model';
import { FeeInfo } from '@/types/tournament.model';

const FEE_FIELDS_MINIMAL = {
  fee: true,
};

const FEE_FIELDS_FULL: CompleteFieldSelector<FeeInfo> = {
  ...FEE_FIELDS_MINIMAL,
  hasToPay: true,
};

export const FEE_FIELDS = {
  MINIMAL: FEE_FIELDS_MINIMAL,
  FULL: FEE_FIELDS_FULL,
} as const;
